import type { TipoObraTagsProps } from "./types-tipo-obra-tags";
import { useTipoObraTags } from "./use-tipo-obra-tags";
import { TipoObraTagsView } from "./view-tipo-obra-tags";

/** Tags dos tipos de uma obra (cards 713:28497 e tabela): uma `TipoObraTag` por código, com a tooltip "código · tipo" quando vem o nome; sem tipos, o travessão. */
export function TipoObraTags(props: TipoObraTagsProps) {
  const vm = useTipoObraTags(props);

  return <TipoObraTagsView {...vm} />;
}

export type * from "./types-tipo-obra-tags";
